module.exports = __webpack_public_path__ + "media/application/images/2018/2018-nav-home-098926c251bed13b65971e38c71fc5f1.svg";